import React from "react";
import ModalButtons from "../ModalButtons/ModalButtons";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import AutoPriceRuleBuilderErrors from "./AutoPriceRuleBuilderErrors";
import Tabs from "../Tabs/Tabs";
import AutoPriceRuleBuilderWorkspace from "./AutoPriceRuleBuilderWorkspace";
import { parseISO, isBefore, isAfter, addDays, subDays } from "date-fns";
import { id } from "date-fns/locale";

class AutoPriceRuleBuilder extends React.Component {
  constructor(props) {
    super(props);
    const pace_array =
      [
        {
          pace_selector: 'very_behind_pace',
          color: "#CC0000",
          percentage: "-(67%-100%)",
          id: 1,
          order: 1
        },

        {
          pace_selector: 'behind_pace',
          color: "#FF3300",
          percentage: "-(34%-66%)",
          id: 2,
          order: 2
        },

        {
          pace_selector: 'slightly_behind_pace',
          color: "#FF6600",
          percentage: "-(1%-33%)",
          id: 3,
          order: 3
        },

        {
          pace_selector: 'on_pace',
          color: "#FFCC00",
          percentage: "(0%)",
          id: 4,
          order: 4
        },

        {
          pace_selector: 'slightly_ahead_of_pace',
          color: "#33CC33",
          percentage: "+(1%-33%)",
          id: 5,
          order: 5
        },

        {
          pace_selector: 'ahead_of_pace',
          color: "#339933",
          percentage: "+(34%-66%)",
          id: 6,
          order: 6
        },

        {
          pace_selector: 'very_ahead_of_pace',
          color: "#336633",
          percentage: "+(67%-100%)",
          id: 7,
          order: 7
        }
      ]
    const occupancy_array =
      [
        {
          id: 1,
          occupancy_percentage: (1 / 9),
          occupancy_comparator: "less_than_or_equal_to",
          order: 1,
          color: "#CC0000",
        },
        {
          id: 2,
          occupancy_percentage: (2 / 9),
          occupancy_comparator: "less_than_or_equal_to",
          order: 2,
          color: "#FF3300",
        },
        {
          id: 3,
          occupancy_percentage: (3 / 9),
          occupancy_comparator: "less_than_or_equal_to",
          order: 3,
          color: "#FF6600",
        },
        {
          id: 4,
          occupancy_percentage: (4 / 9),
          occupancy_comparator: "less_than_or_equal_to",
          order: 4,
          color: "#FFCC00",
        },
        {
          id: 5,
          occupancy_percentage: (5 / 9),
          occupancy_comparator: "greater_than_or_equal_to",
          order: 5,
          color: "#33CC33",
        },
        {
          id: 6,
          occupancy_percentage: (6 / 9),
          occupancy_comparator: "greater_than_or_equal_to",
          order: 6,
          color: "#339933",
        },
        {
          id: 7,
          occupancy_percentage: (7 / 9),
          occupancy_comparator: "greater_than_or_equal_to",
          order: 7,
          color: "#336633",
        },
        {
          id: 8,
          occupancy_percentage: (8 / 9),
          occupancy_comparator: "greater_than_or_equal_to",
          order: 8,
          color: "#336633",
        },
      ]
    this.state = {
      activeTab: "general",
      loading: false,
      all_room_types: this.props.all_room_types,
      all_rates: this.props.all_rates,
      errors: this.props.errors ? this.props.errors : null,
      name: this.props.name,
      code: this.props.code,
      start_date: this.props.start_date
        ? parseISO(this.props.start_date)
        : null,
      end_date: this.props.end_date ? parseISO(this.props.end_date) : null,
      begin_days_out: this.props.begin_days_out,
      end_days_out: this.props.end_days_out,
      id: this.props.id,
      name: this.props.name,
      read_only:
        typeof this.props.read_only != "undefined"
          ? this.props.read_only
          : false,
      property_wide: this.props.property_wide ? "property" : "room_type",
      status: this.props.status,
      updated_at: this.props.updated_at,
      auto_price_rules_for_date_range: this.props.dynamic_price_adjustments ? this.props.dynamic_price_adjustments : [],
      pace: this.props.pace,
      occupancy: this.props.occupancy,
      selected: false,
      pace_array: pace_array,
      occupancy_array: occupancy_array,
      price_type: this.props.price_type,
      // order: this.props.order ? this.props.order : 0,
    }

    this.onChange = this.onChange.bind(this);
    this.onChangeAutoPriceRates = this.onChangeAutoPriceRates.bind(this);
    this.onSave = this.onSave.bind(this);
    this.onSetActiveTab = this.onSetActiveTab.bind(this);
    this.onChangeRoomTypes = this.onChangeRoomTypes.bind(this);
    this.onChangeAmount = this.onChangeAmount.bind(this);
    this.onChangePercentage = this.onChangePercentage.bind(this);
    this.onChangePropertyWide = this.onChangePropertyWide.bind(this);
    this.onChangePaceOrOccupancy = this.onChangePaceOrOccupancy.bind(this);
    this.onClickPace = this.onClickPace.bind(this);
    this.onClearPriceAdjustment = this.onClearPriceAdjustment.bind(this);
    this.onClickOk = this.onClickOk.bind(this);
    this.onClickOccupancy = this.onClickOccupancy.bind(this);
    this.onChangeOccupancyComparator = this.onChangeOccupancyComparator.bind(this);
  }

  componentDidUpdate() {
    if (this.refs.startDate || this.refs.endDate) {
      window.initDatepickers();
    }
  }

  render() {
    var self = this;
    var buttons = [
      {
        name: I18n.t("cancel"),
        html_attributes: ['data-dismiss="modal"'],
      },
      {
        name: I18n.t("submit"),
        button_classes: ["primary"],
        onClick: function (e) {
          e.stopPropagation();
          e.preventDefault();
          self.onSave();
        },
      },
    ];

    return (
      <div className="auto-price-rule-builder" ref="root">
        <div className="auto-price-rule">
          <Tabs tabs={this.tabs()} />
          <div className="panel panel-form">
            <AutoPriceRuleBuilderWorkspace
              {...this.state}
              date_format={this.props.date_format}
              disabled={this.props.disabled}
              onChange={this.onChange}
              onChangeAutoPriceRates={this.onChangeAutoPriceRates}
              onChangePropertyWide={this.onChangePropertyWide}
              time_format={this.props.time_format}
              onChangeAmount={this.onChangeAmount}
              onChangePercentage={this.onChangePercentage}
              onChangeRoomTypes={this.onChangeRoomTypes}
              onChangeEndDate={this.onChangeEndDate}
              onChangeStartDate={this.onChangeStartDate}
              onChangePaceOrOccupancy={this.onChangePaceOrOccupancy}
              onClickPace={this.onClickPace}
              onClearPriceAdjustment={this.onClearPriceAdjustment}
              onClickOk={this.onClickOk}
              onClickOccupancy={this.onClickOccupancy}
              onChangeOccupancyComparator={this.onChangeOccupancyComparator}
              onSetActiveTab={this.onSetActiveTab}
            />
          </div>
        </div>
        <ModalButtons loading={this.state.loading} buttons={buttons} />
        <LoadingSpinner show={this.state.loading} />
      </div>
    );
  }

  tabs() {
    if (this.state.selected != false) {
      return [
        {
          tabName: I18n.t("general"),
          targetName: "general",
          classes: this.state.activeTab === "general" ? "active" : null,
          changeHandler: this.onSetActiveTab,
          tabErrorCount: AutoPriceRuleBuilderErrors.generalErrors(
            this.state.errors
          ).length,
        },
        {
          tabName: I18n.t("room_types"),
          targetName: "room_types",
          classes: this.state.activeTab === "room_types" ? "active" : null,
          changeHandler: this.onSetActiveTab,
          tabErrorCount: AutoPriceRuleBuilderErrors.roomTypesErrors(
            this.state.errors
          ).length,
        },
        {
          tabName: I18n.t("rates"),
          targetName: "rates",
          classes: this.state.activeTab === "rates" ? "active" : null,
          changeHandler: this.onSetActiveTab,
          tabErrorCount: AutoPriceRuleBuilderErrors.ratesErrors(this.state.errors)
            .length,
        },
      ];
    } else {
      return [
        {
          tabName: I18n.t("general"),
          targetName: "general",
          classes: this.state.activeTab === "general" ? "active" : null,
          changeHandler: this.onSetActiveTab,
          tabErrorCount: AutoPriceRuleBuilderErrors.generalErrors(
            this.state.errors
          ).length,
        },
      ];
    }
  }

  onChange(event) {
    if (event && event.target) {
      var state = Object.assign({}, this.state);

      if (
        event.target.name == "occupancy_comparator" ||
        event.target.name == "occupancy_percentage"
      ) {
        state.pace_selector = null;
      }

      state[event.target.name] = event.target.value;
      this.setState(state);
    }
  }

  onChangePaceOrOccupancy(event) {
    this.setState({ pace_or_occupancy: event.target.value })
  }

  onChangeAutoPriceRates(auto_price_rates) {
    var auto_price_rules_for_date_range = this.state.auto_price_rules_for_date_range
    var found = false

    if (auto_price_rules_for_date_range != []) {
      var found = false;

      if (auto_price_rules_for_date_range) {
        for (var i = 0, ilen = auto_price_rules_for_date_range.length; i < ilen; i++) {
          if (auto_price_rules_for_date_range[i].id === this.state.selected[0]) {
            found = true;
            break;
          }
        }
      }
    }
    if (found) {
      auto_price_rules_for_date_range.map(price_rule => {
        if (price_rule.id === this.state.selected[0]) {
          price_rule.auto_price_rates = auto_price_rates
        }
      })
    } else {
      if (!auto_price_rules_for_date_range) {
        auto_price_rules_for_date_range = []
      } else {
        var new_price_rule = {
          id: this.state.selected[0],
          auto_price_rates: auto_price_rates,
          auto_price_rates: []
        }
      }

      auto_price_rules_for_date_range.push(new_price_rule)
    }

    this.setState({ auto_price_rules_for_date_range: auto_price_rules_for_date_range })
  }

  onChangeRoomTypes(room_types) {
    var auto_price_rules_for_date_range = this.state.auto_price_rules_for_date_range
    var found = false

    if (auto_price_rules_for_date_range != []) {
      var found = false;

      if (auto_price_rules_for_date_range) {
        for (var i = 0, ilen = auto_price_rules_for_date_range.length; i < ilen; i++) {
          if (auto_price_rules_for_date_range[i].id === this.state.selected[0]) {
            found = true;
            break;
          }
        }
      }
    }

    if (found) {
      auto_price_rules_for_date_range.map(price_rule => {
        if (price_rule.id === this.state.selected[0]) {
          price_rule.room_types = room_types
        }
      })
    } else {
      if (!auto_price_rules_for_date_range) {
        auto_price_rules_for_date_range = []
      } else {
        var new_price_rule = {
          id: this.state.selected[0],
          room_types: room_types,
          auto_price_rates: []
        }
      }

      auto_price_rules_for_date_range.push(new_price_rule)
    }

    this.setState({ auto_price_rules_for_date_range: auto_price_rules_for_date_range })
  }

  onChangeAmount(amount, pace) {
    var auto_price_rules_for_date_range = this.state.auto_price_rules_for_date_range
    var found = false

    if (auto_price_rules_for_date_range != []) {
      var found = false;

      if (auto_price_rules_for_date_range) {
        for (var i = 0, ilen = auto_price_rules_for_date_range.length; i < ilen; i++) {
          if (auto_price_rules_for_date_range[i].id === pace.id) {
            found = true;
            break;
          }
        }
      }
    }
    if (found) {
      auto_price_rules_for_date_range.map(price_rule => {
        if (price_rule.id === pace.id) {
          price_rule.id = pace.id
          price_rule.amount = amount
          price_rule.percentage = null
          price_rule.pace_selector = pace.pace_selector
          price_rule.occupancy_percentage = pace.occupancy_percentage
          price_rule.occupancy_comparator = pace.occupancy_comparator
          price_rule.order = pace.order

        }
      })
    } else {
      if (!auto_price_rules_for_date_range) {
        auto_price_rules_for_date_range = []
      } else {
        var new_price_rule = {
          id: pace.id,
          amount: amount,
          pace_selector: pace.pace_selector,
          percentage: null,
          occupancy_percentage: pace.occupancy_percentage,
          occupancy_comparator: pace.occupancy_comparator,
          order: pace.order
        }
      }

      auto_price_rules_for_date_range.push(new_price_rule)
    }

    this.setState({ auto_price_rules_for_date_range: auto_price_rules_for_date_range })
  }

  onChangePercentage(percentage, pace) {
    var auto_price_rules_for_date_range = this.state.auto_price_rules_for_date_range
    var found = false

    if (auto_price_rules_for_date_range != []) {
      var found = false;

      if (auto_price_rules_for_date_range) {
        for (var i = 0, ilen = auto_price_rules_for_date_range.length; i < ilen; i++) {
          if (auto_price_rules_for_date_range[i].id === pace.id) {
            found = true;
            break;
          }
        }
      }
    }

    if (found) {
      auto_price_rules_for_date_range.map(price_rule => {
        if (price_rule.id === pace.id) {
          price_rule.id = pace.id
          price_rule.amount = null
          price_rule.percentage = percentage
          price_rule.pace_selector = pace.pace_selector
          price_rule.occupancy_percentage = pace.occupancy_percentage
          price_rule.order = pace.order
          price_rule._destroy = false
        }
      })
    } else {
      if (!auto_price_rules_for_date_range) {
        auto_price_rules_for_date_range = []
      } else {
        var new_price_rule = {
          id: pace.id,
          amount: null,
          pace_selector: pace.pace_selector,
          percentage: percentage,
          occupancy_percentage: pace.occupancy_percentage,
          order: pace.order
        }
      }
      auto_price_rules_for_date_range.push(new_price_rule)
    }
    this.setState({ auto_price_rules_for_date_range: auto_price_rules_for_date_range })
  }

  onClickPace(e, pace) {
    var auto_price_rules_for_date_range = this.state.auto_price_rules_for_date_range
    var found = false

    if (auto_price_rules_for_date_range != []) {
      var found = false;

      if (auto_price_rules_for_date_range) {
        for (var i = 0, ilen = auto_price_rules_for_date_range.length; i < ilen; i++) {
          if (auto_price_rules_for_date_range[i].id === pace.id) {
            found = true;
            break;
          }
        }
      }
    }
    if (found) {
      auto_price_rules_for_date_range.map(price_rule => {
        if (price_rule.id === pace.id) {
          price_rule.id = pace.id
          price_rule.pace_selector = pace.pace_selector
          price_rule.room_types = price_rule.room_types ? price_rule.room_types : []
          price_rule.auto_price_rates = price_rule.auto_price_rates ? price_rule.auto_price_rates : []
          price_rule.order = pace.order
          price_rule._destroy = false
        }
      })
    } else {
      if (!auto_price_rules_for_date_range) {
        auto_price_rules_for_date_range = []
      } else {
        var new_price_rule = {
          id: pace.id,
          pace_selector: pace.pace_selector,
          room_types: [],
          auto_price_rates: [],
          order: pace.order,
          _destroy: false
        }
      }

      auto_price_rules_for_date_range.push(new_price_rule)
    }

    this.setState({
      selected: [pace.id, true, pace],
      auto_price_rules_for_date_range: auto_price_rules_for_date_range
    })
  }

  onClickOccupancy(e, occupancy) {
    var auto_price_rules_for_date_range = this.state.auto_price_rules_for_date_range
    var found = false

    if (auto_price_rules_for_date_range != []) {
      var found = false;
      if (auto_price_rules_for_date_range) {
        for (var i = 0, ilen = auto_price_rules_for_date_range.length; i < ilen; i++) {
          if (auto_price_rules_for_date_range[i].id === occupancy.id) {
            found = true;
            break;
          }
        }
      }
    }
    
    if (found) {
      // console.log("found", found);
      auto_price_rules_for_date_range.map(price_rule => {
        if (price_rule.id === occupancy.id) {
          price_rule.id = occupancy.id
          price_rule.occupancy_percentage = occupancy.occupancy_percentage
          price_rule.occupancy_comparator = occupancy.occupancy_comparator
          price_rule.room_types = price_rule.room_types ? price_rule.room_types : []
          price_rule.auto_price_rates = price_rule.auto_price_rates ? price_rule.auto_price_rates : []
          price_rule.order = occupancy.order
          price_rule._destroy = false
        }
      })
    } else {
      if (!auto_price_rules_for_date_range) {
        auto_price_rules_for_date_range = []
      } else {
        var new_price_rule = {
          id: occupancy.id,
          occupancy_percentage: occupancy.occupancy_percentage,
          occupancy_comparator: occupancy.occupancy_comparator,
          room_types: [],
          auto_price_rates: [],
          order: occupancy.order,
          _destroy: false
        }
      }

      auto_price_rules_for_date_range.push(new_price_rule)
    }

    this.setState({
      selected: [occupancy.id, true, occupancy],
      auto_price_rules_for_date_range: auto_price_rules_for_date_range
    })
  }

  onChangeOccupancyComparator(e, occupancy) {
    var auto_price_rules_for_date_range = this.state.auto_price_rules_for_date_range
    var found = false

    if (auto_price_rules_for_date_range != []) {
      var found = false;

      if (auto_price_rules_for_date_range) {
        for (var i = 0, ilen = auto_price_rules_for_date_range.length; i < ilen; i++) {
          if (auto_price_rules_for_date_range[i].id === occupancy.id) {
            found = true;
            break;
          }
        }
      }
    }

    if (found) {
      auto_price_rules_for_date_range.map(price_rule => {
        if (price_rule.id === occupancy.id) {
          price_rule.occupancy_comparator = e.target.value
          price_rule.occupancy_percentage = occupancy.occupancy_percentage
          price_rule.order = occupancy.order
          price_rule._destroy = false
        }
      })
    } else {
      if (!auto_price_rules_for_date_range) {
        auto_price_rules_for_date_range = []
      } else {
        var new_price_rule = {
          id: occupancy.id,
          occupancy_comparator: e.target.value,
          occupancy_percentage: occupancy.occupancy_percentage,
          order: occupancy.order,
          _destroy: false
        }
      }

      auto_price_rules_for_date_range.push(new_price_rule)
    }

    this.setState({ auto_price_rules_for_date_range: auto_price_rules_for_date_range })
  }

  onClearPriceAdjustment(e, pace) {   
    const auto_price_rules_for_date_range = this.state.auto_price_rules_for_date_range
    auto_price_rules_for_date_range.map((price_rule, idx) => {
      if (price_rule.id === pace.id) {
        price_rule.pace_selector = null
        price_rule.amount = null
        price_rule.percentage = null
        // price_rule.occupancy_percentage = null
        price_rule.occupancy_comparator = null
        price_rule.room_types = []
        price_rule.auto_price_rates = []
        price_rule._destroy = true
      }
    })

    this.setState({
      auto_price_rules_for_date_range: auto_price_rules_for_date_range,
      selected: false
    })
  }

  onClickOk(e, pace) {
    this.setState({ selected: false })
  }

  onChangePropertyWide(event) {
    if (event.target.name == "room_type") {
      this.setState({ property_wide: false });
    } else {
      this.setState({ property_wide: true });
    }
  }

  onSave() {
    var self = this;
    this.setState({ loading: true });
    var params = this.prepParams();

    $.ajax({
      type: this.props.new_record ? "POST" : "PUT",
      url: this.props.form_action,
      data: params,
    })
      .done((data) => {
        window.parent.$(window.parent).trigger("autoPriceRuleSaved", data);
        this.setState({ loading: false });
        if (parent && parent.refresh_data) {
          if (this.props.new_record == true) {
            parent.refresh_data(
              I18n.t("automatic_price_rule_created_successfully")
            );
          } else {
            parent.refresh_data(
              I18n.t("automatic_price_rule_saved_successfully")
            );
          }
        }
        if (parent && parent.hide_modal) {
          parent.hide_modal();
        }
      })
      .catch((data) => {
        // console.log("data", data);
        if (data && data.responseJSON) {
          this.setState({ errors: data.responseJSON, loading: false });
          $(".modal-body").scrollTop(0);
        }
      });
  }

  onSetActiveTab(name) {
    this.setState({ activeTab: name });
  }

  onChangeStartDate = (startDate) => {
    if (isAfter(startDate, this.state.end_date)) {
      this.setState({
        start_date: startDate,
        end_date: addDays(startDate, 1),
      });
    } else {
      this.setState({
        start_date: startDate,
      });
    }
  };

  onChangeEndDate = (endDate) => {
    if (isBefore(endDate, this.state.start_date)) {
      this.setState({
        start_date: subDays(endDate, 1),
        end_date: endDate,
      });
    } else {
      this.setState({
        end_date: endDate,
      });
    }
  };

  generateId() {
    var text = "";
    var possible = "0123456789";

    for (var i = 0; i < 9; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return "-" + text;
  }

  isUUID(id) {
    return /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(id);
  }

  prepParams() {
    const params = {
      dynamic_price: {
        name: this.state.name,
        code: this.state.code,
        status: this.state.status,
        start_date: this.state.start_date,
        end_date: this.state.end_date,
        begin_days_out: this.state.begin_days_out,
        end_days_out: this.state.end_days_out,
        property_wide: this.state.property_wide === "room_type" ? false : true,
        updated_at: this.props.updated_at,
        price_type: this.state.price_type,
        // auto_price_type: this.props.pace ? "pace" : "occupancy",
        // Optional: include dynamic_price ID if valid
        ...(this.state.id && this.isUUID(this.state.id) ? { id: this.state.id } : {}),
        dynamic_price_adjustments_attributes: this.state.auto_price_rules_for_date_range.map((price_adjustment) => {
          const adjustment = {
            room_type_ids: (price_adjustment.room_types || []).filter(this.isUUID),
            rate_ids: (price_adjustment.auto_price_rates || []).filter(this.isUUID),
            occupancy_percentage: price_adjustment.occupancy_percentage,
            occupancy_comparator: price_adjustment.occupancy_comparator,
            percentage: price_adjustment.percentage,
            amount: price_adjustment.amount,
            pace_selector: price_adjustment.pace_selector,
            order: price_adjustment.order,
            _destroy: price_adjustment._destroy
          };
          if (this.isUUID(price_adjustment.id)) {
            adjustment.id = price_adjustment.id;
          }

          return adjustment;
        })
      }
      // console.log("prepParams params", params)
    };

    return params;
  }

  // prepParams() {
  //   console.log("AutoPriceRuleBuilder prepParams", this.state.auto_price_rules_for_date_range)
  //   var params = {
  //     dynamic_price: {
  //       name: this.state.name,
  //       code: this.state.code,
  //       status: this.state.status,
  //       start_date: this.state.start_date,
  //       end_date: this.state.end_date,
  //       begin_days_out: this.state.begin_days_out,
  //       end_days_out: this.state.end_days_out,
  //       property_wide: this.state.property_wide == "room_type" ? false : true,
  //       updated_at: this.props.updated_at,
  //       auto_price_type: this.props.pace ? "pace" : "occupancy",
  //       dynamic_price_adjustments_attributes: this.state.auto_price_rules_for_date_range.map((price_adjustment) => {
  //         return {
  //           id: price_adjustment.id,
  //           room_type_ids: price_adjustment.room_types,
  //           rate_ids: price_adjustment.auto_price_rates,
  //           occupancy_percentage: price_adjustment.occupancy_percentage,
  //           occupancy_comparator: price_adjustment.occupancy_comparator,
  //           percentage: price_adjustment.percentage,
  //           amount: price_adjustment.amount,
  //           pace_selector: price_adjustment.pace_selector,
  //           order: price_adjustment.order
  //         }
  //       })
  //     },
  //     // auto_price_rules_for_date_range: JSON.stringify(this.state.auto_price_rules_for_date_range),
  //   };
  //   return params;
  // }
}

export default AutoPriceRuleBuilder;
